<template>
  <div>
    <b-card style="background-color: transparent" border-variant="light">
      <div v-if="!fetching">
        <div class="container">
          <TypingEssayLessonCard :backgroundId="1" :titleText="$t('Typing.practice')">
            <template v-slot:button>
              <div class="custom-card-button-container">
                <div class="button" :id="`typing-practice`">
                  <b-button
                    :disabled="!unlocked"
                    pill
                    variant="outline-success"
                    :to="{
                      name: 'typingEssay',
                      params: { isPractice: true, fromParent: true, typingEssayRule: typingEssayPracticeRule }
                    }"
                  >{{ $t('Common.goInto') }}</b-button>
                </div>
                <b-tooltip
                  v-if="!unlocked"
                  :target="`typing-practice`"
                  placement="bottom"
                  noninteractive
                >{{ $t('Typing.notUnlockedYet') }}</b-tooltip>
              </div>
            </template>
          </TypingEssayLessonCard>
          <TypingEssayLessonCard :backgroundId="2" :titleText="$t('Typing.test')">
            <template v-slot:button>
              <div class="custom-card-button-container">
                <div class="button" :id="`typing-test`">
                  <b-button
                    :disabled="!unlocked"
                    pill
                    variant="outline-success"
                    :to="{
                      name: 'typingEssay',
                      params: { isPractice: false, fromParent: true, typingEssayRule: typingEssayTestRule }
                    }"
                  >{{ $t('Common.goInto') }}</b-button>
                </div>
                <b-tooltip
                  v-if="!unlocked"
                  :target="`typing-test`"
                  placement="bottom"
                  noninteractive
                >{{ $t('Typing.notUnlockedYet') }}</b-tooltip>
              </div>
            </template>
          </TypingEssayLessonCard>
        </div>
      </div>
      <div v-else>
        <b-spinner variant="success" type="grow" label="Spinning"></b-spinner>
      </div>
    </b-card>
  </div>
</template>

<script lang='js'>
import Vue from 'vue'
import { mapState } from 'vuex'
import TypingEssayLessonCard from '@/components/Typing/TypingEssay/TypingEssayLessonCard.vue'

const TypingCombineLessonList = Vue.extend({
  name: 'TypingCombineLessonList',
  components: {
    TypingEssayLessonCard
  },
  mounted () {
    this.$store.dispatch('typingEssay/fetchTypingEssayRules')
  },
  computed: {
    ...mapState({
      unlocked: state => state.typingEssay.unlocked,
      typingEssayPracticeRule: state => state.typingEssay.typingEssayPracticeRule,
      typingEssayTestRule: state => state.typingEssay.typingEssayTestRule,
      fetching: state => state.typingEssay.fetching
    })
  }
})

export default TypingCombineLessonList
</script>

<style lang='scss' scoped>
.container {
  display: flex;
  justify-content: space-evenly;
}
</style>
